import { BusinessCharType } from '../redux/businesses';
import { Api } from './api';

export class BusinessesApi {
    private static readonly PATH = '/businesses';
    
    constructor(private readonly m_api: Api) {}

    public async getLib() {
        return this.m_api.get(BusinessesApi.PATH);
    }

    public async start(type: number) {
        return this.m_api.post(`${BusinessesApi.PATH}/start`, { type });
    }

    public async upgradeChar(businessType: number, char: BusinessCharType) {
        return this.m_api.post(`${BusinessesApi.PATH}/upgrade-char`, { businessType, char });
    }

    public async upgradeElement(businessType: number, elementType: number) {
        return this.m_api.post(`${BusinessesApi.PATH}/upgrade-element`, { businessType, elementType });
    }

    public async setName(businessType: number, name: string) {
        return this.m_api.post(`${BusinessesApi.PATH}/set-name`, { businessType, name });
    }
}